module.exports = __webpack_public_path__ + "img/public/SiteIcons/hostStepIcons/features.svg?5b48973b";